import { LOCALES, LOCALE_NAMES, useLocale } from '@/i18n/locale'
import { useMessages } from '@/i18n/messages'
import { commonMessages } from '@/i18n/common'
import { usePreferences } from '@/lib/preferences'

export function LanguageSwitcher({ className = '' }: { className?: string }) {
  const locale = useLocale()
  const m = useMessages(commonMessages)
  const { setLanguage } = usePreferences()

  return (
    <div
      role="group"
      aria-label={m.language}
      className={`inline-flex flex-none rounded-[10px] border border-[var(--border)] bg-[var(--surface)] p-0.5 ${className}`}
    >
      {LOCALES.map((l) => (
        <button
          key={l}
          type="button"
          lang={l}
          title={LOCALE_NAMES[l]}
          aria-pressed={l === locale}
          onClick={() => setLanguage(l)}
          className={`rounded-lg px-2 py-1 font-grotesk text-[11px] font-bold tracking-wide transition ${
            l === locale
              ? 'bg-[var(--brand)] text-[var(--on-brand)]'
              : 'text-[var(--fg-soft)] hover:bg-[var(--surface-2)] hover:text-[var(--fg)]'
          }`}
        >
          {l.toUpperCase()}
        </button>
      ))}
    </div>
  )
}
